// -*- Mode: rjsx -*-
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { Notification } from './assistant/notifications';

import { UnclaimedList,
         ClaimedList,
         UnclaimedMentorList,
         UnclaimedCallList }
from './assistant/requestlist';

import { PhoneClient } from './assistant/request/';


import DwollaSetup from './containers/DwollaSetup';
import RequestNotes from './containers/RequestNotes';
import NavRoot from './containers/NavRoot';
import PasswordChange from './containers/PasswordChange';
import PasswordSignIn from './containers/PasswordSignIn';
import PasswordReset from './containers/PasswordReset';
import PasswordSet from './containers/PasswordSet';
import AssistantSignup from './containers/AssistantSignup';

// import AdminMain from './containers/AdminMain';

import { FancyTextEntry } from './ui';

import RealtimeClient from './data/RealtimeClient';

import { ThemeProvider } from '@mui/styles';
import { StyledEngineProvider } from '@mui/material/styles';

import { FHTheme } from './ui'; 


import Store from './app/Store';


if(window.ALL_JS_LOADED === undefined) {

    window.ALL_JS_LOADED = true;
    let store = Store;
    console.log("Loading everything");
    RealtimeClient.init(store.dispatch,
			            window.pageVariables.morty_token,
			            window.pageVariables.user);
    
    var rootMap = [
        
	    ['notification-root', <Notification />],
	    ['request-notes-root', <RequestNotes />],
	    ['unclaimed-tasks-root', <UnclaimedList />],
	    ['claimed-tasks-root', <ClaimedList />],        
        
	    ['unclaimed-mentor-tasks-root', <UnclaimedMentorList />],
        ['unclaimed-call-tasks-root', <UnclaimedCallList />],
	    ['nav-root', <NavRoot />],
	    ['dwolla-setup-root', <DwollaSetup />],

	    ['phone-client-root', <PhoneClient />],                
        
	    // ['claimed-tasks-root', <ClaimedTasks />],
	    // ['my-claimed-tasks-root', <MyClaimedTasks />],
	    // ['tutorial-tasks-root', <TutorialTasks />],    
	    // ['chat-root', <ChatContainer />],
	    // ['permission-quiz-root', <PermissionQuiz />],

	    // ['project-root', <ProjectContainer />],
	    // ['odo-application-list-root', <ODOApplicationList />],
	    // ['project-phone-conversations', <ProjectPhoneConversations />],
	    // ['conversation-viewer', <Conversation />],    	

        
	    // ['la-stats-root', <LaStatsContainer />],


	    // ['fh-api-tasks-root', <ApiTasks />],
	    // ['fh-api-stats-root', <ApiStats />],
	    // ['fh-api-templates-root', <ApiTemplates />],

	    ['react-password-change', <PasswordChange />],
	    ['react-password-sign-in', <PasswordSignIn />],
	    ['react-password-reset', <PasswordReset />],
	    ['react-password-set', <PasswordSet />],
	    ['react-assistant-signup', <AssistantSignup />],

        
	    ['fancy-text-entry-root', <FancyTextEntry />],

	    // ['fancy-hands-admin-root', <AdminMain />],        
    ];

    rootMap.map( o => {
	    let rootId = o[0];
	    let className = o[1];
	    let element = document.getElementById(rootId);

	    if(element) {
//            console.log("mapping %s, %s", rootId, className);                    
	        let pv = window.pageVariables;            
	        let vals = {
                defaultTitle: element.getAttribute('data-title')
            };

	        // console.log("trying: %o, pv: %o", rootId, pv);
	        if(pv && (pv.initialReactProps !== undefined)) 
		        vals = { ...vals, ...pv.initialReactProps};

	        let E = React.cloneElement(className, vals );
	        ReactDOM.render(
		        <Provider store={store} >
                  <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={FHTheme}>
                        {E}
                      </ThemeProvider>
                  </StyledEngineProvider>
		        </Provider>,
		        document.getElementById(rootId)
	        );
	    }
    });
    

}
